
namespace RioERP.Shipping {

    @Serenity.Decorators.registerClass()
    export class ShippingTrackingNumbersGrid extends Serenity.EntityGrid<ShippingTrackingNumbersRow, any> {
        protected getColumnsKey() { return ShippingTrackingNumbersColumns.columnsKey; }
        protected getDialogType() { return ShippingTrackingNumbersDialog; }
        protected getIdProperty() { return ShippingTrackingNumbersRow.idProperty; }
        protected getInsertPermission() { return ShippingTrackingNumbersRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingTrackingNumbersRow.localTextPrefix; }
        protected getService() { return ShippingTrackingNumbersService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);


            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: ShippingTrackingNumbersService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push({
                title: 'Import From Excel',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new ShippingTrackingNumbersExcelImportDialog();
                    dialog.element.on('dialogclose', () => {
                        this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();
                }
            });

            buttons.push({
                title: 'Download Shipping Tracking Number Sample',
                cssClass: 'export-xlsx-button',
                onClick: () => {
                    /*  debugger;*/
                    var url = "~/Workspace/Shipping/ShippingTrackingNumbersImportSample";
                    /*var url = "~/Uploads/ProductsImportSample.xlsx";*/

                    Q.postToService({ url: Q.resolveUrl(url), request: '', target: '_blank' });
                }
            });
            return buttons;
        }
    }
}